import RouterLink from "../link/RouterLink";
import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic"

import { useStoryblokGlobalSettings } from "../../hooks/useStoryblokGlobalSettings"

import styles from "./authorThumbnail.module.scss"
import {authorUrlFromSlug} from "../../helpers/URLHelpers";

function AuthorThumbnail({ image, name, slug }) {
  const globalSettings = useStoryblokGlobalSettings()

  let newImage = image
  if(!newImage || !newImage.filename) {
    newImage = globalSettings.default_author_image
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.authorThumbnail}>
        {newImage && newImage.filename ? (
          <RouterLink to={authorUrlFromSlug(slug)} className={styles.image}>
            <StoryblokImageBasic image={newImage} />
          </RouterLink>
        ) : null}
        {name ? (
          <RouterLink to={authorUrlFromSlug(slug)} className={styles.name}>{name}</RouterLink>
        ) : null}
      </div>
    </div>
  )
}

export default AuthorThumbnail
